export default __webpack_public_path__ + "static/media/what_we_do_image.55951f6f.svg";